import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Native Select Design Guidelines",
  "title": "Native Select",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="native_select" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  The Select component allows users to choose one or more options from a list.
      </LeadParagraph>
      <h2>{`Usage`}</h2>
      <p>{`The Native Select functionally works the same as the standard Select. The difference is that the Native Select lets the browser determine how the list of options is presented. This makes it the preferred component when the list of options is longer than 10 items. This will ensure the list is navigable and optimized for any size screen.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.4015444015444%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsTAAALEwEAmpwYAAABUUlEQVQoz5WSTUsCURSG/Q+16WNji0KKqbBMLPGDHKGSTOhj06JFa/+HkCFEkuBGIehf9FOiRTgzd9S583Et6Lwx04yYWOSFl3Pg3PucZ3FDtm0jiGVZXjVNE7ZtYSAciCCOA2vCXb+noIbGgY7joNNR8PL6BoX1obKeF9bte3N3WQAbqZOB3DSBz3c0np6RvG7hoPyI6GUTK6cNFMpt9HtdDAYfMAz+P0POOdxTua1jNSYjni1iYTmO2XAUif0SFEWFEGIKQx94U7uHtJVCvnCGyEYC8+E1pOVjqKo2BE5lWK3VIW1nkDt0gXuYW5KQzp/8AP5lSEE45wSAKtU7imwmSS6c0/pOlmYWI7SbPSJFVUkIQT5gPC6cQoG+m29DwkOzhZRcROniCqlcEVIs4/WM6d4vGH3jZ7JhsNkwDNI0RozppGqa1+u6Ppz/ZugCvwDbTHE16fsSoQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "native select example",
            "title": "native select example",
            "src": "/static/567ec601f3d3637b89c26f121a10a069/e3189/native-select-example.png",
            "srcSet": ["/static/567ec601f3d3637b89c26f121a10a069/a2ead/native-select-example.png 259w", "/static/567ec601f3d3637b89c26f121a10a069/6b9fd/native-select-example.png 518w", "/static/567ec601f3d3637b89c26f121a10a069/e3189/native-select-example.png 1035w", "/static/567ec601f3d3637b89c26f121a10a069/aa440/native-select-example.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      